import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../store"
import { FilterID, FilterIDs, Thread } from "../../types"

interface ConversationState {
  selectedBrand?: number
  imagePreview?: string
  currentThread?: Thread
  showCurrentThreadDetailsView: boolean
  currentFilter: FilterIDs
}

const initialState: ConversationState = {
  showCurrentThreadDetailsView: false,
  currentFilter: []
}

const conversationsSlice = createSlice({
  name: "conversations",
  initialState,
  reducers: {
    setSelectedBrand(state, action: PayloadAction<number | undefined>) {
      state.selectedBrand = action.payload
    },
    clearSelectedBrand(state) {
      state.selectedBrand = undefined
    },
    setImagePreview(state, action: PayloadAction<string | undefined>) {
      state.imagePreview = action.payload
    },
    clearImagePreview(state) {
      state.imagePreview = undefined
    },
    setCurrentThread(state, action: PayloadAction<Thread | undefined>) {
      state.currentThread = action.payload
    },
    toggleCurrentThreadDetailsView(state) {
      state.showCurrentThreadDetailsView = !state.showCurrentThreadDetailsView
    },
    clearCurrentThread(state) {
      state.currentThread = undefined
    },
    setFilters(state, action: PayloadAction<FilterID>) {
      const value = action.payload
      state.currentFilter = state.currentFilter.includes(value)
        ? state.currentFilter.filter(f => f !== value)
        : [...state.currentFilter, value]
    }
  }
})

export const {
  setSelectedBrand,
  clearSelectedBrand,
  setImagePreview,
  clearImagePreview,
  setCurrentThread,
  toggleCurrentThreadDetailsView,
  clearCurrentThread,
  setFilters: setConversationsFilter
} = conversationsSlice.actions

// Selector to get the selectedBrand value
export const selectSelectedBrand = (state: RootState) =>
  state.conversations.selectedBrand
export const imagePreview = (state: RootState) =>
  state.conversations.imagePreview
export const currentThread = (state: RootState) =>
  state.conversations.currentThread
export const showCurrentThreadDetailsView = (state: RootState) =>
  state.conversations.showCurrentThreadDetailsView
export const currentFilter = (state: RootState) =>
  state.conversations.currentFilter

export default conversationsSlice.reducer
